import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

const TextArea = ({ defaultValue, value, onChange, classNameParent, className, text, size, icon, append, invalid, smallColor, ...props }) => {
  const propInput = useCallback(() => {
    return defaultValue !== undefined && defaultValue !== null ? { defaultValue } : { value }
  }, [defaultValue, value])

  const hasAddon = !!(icon || (append && React.Children.count(append) > 0))

  return (
    <div className={classNameParent}>
      {text ? (
        <label className={`sp-field-label ${smallColor || ''}`.trim()} htmlFor={props.id}>
          {text}
        </label>
      ) : null}
      <div className={`sp-field-control input-group input-group-${size} ${hasAddon ? 'sp-field-control--addon' : ''}`.trim()}>
        <textarea
          {...props}
          {...propInput()}
          onChange={onChange}
          className={'form-control ' + className}
        />
        {append && React.Children.count(append) > 0 ? (
          <div className="input-group-append">
            {React.Children.toArray(append)}
          </div>
        ) : null}
      </div>
      {invalid ? <div className="invalid-feedback d-block">{invalid}</div> : null}
    </div>
  )
}
TextArea.defaultProps = {
  size: 'sm',
  icon: '',
  classNameParent: 'col-12',
  required: false,
  append: [],
  className: '',
  onChange: () => {},
  smallColor: 'text-muted',
  invalid: ''
}
TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'lg']),
  classNameParent: PropTypes.string,
  icon: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  append: PropTypes.array,
  maxLength: PropTypes.number,
  onChange: PropTypes.func
}
export default TextArea
